import logo from './logo.svg';
import React, { useEffect, useState } from 'react';
import './App.css';

function App() {

  const [segundos, setSegundos] = useState(5);

  useEffect(() => {
      if(segundos===0){
         window.location.href = "https://calendly.com/get_desk/demo_com_especialista"
      }
  
      if (!segundos) return;
  
      const intervalId = setInterval(() => {
  
        setSegundos(segundos - 1);
      }, 1000);
  
      return () => clearInterval(intervalId);
    }, [segundos]);
  
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <br></br>
        <p style={{ color: 'black' }}>
          Em {segundos} segundos, você será redirecionado!
        </p>
      </header>
    </div>
  );
}

export default App;
